// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","form":"_1LDSHt4db2Vg"};